import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Checkbox, Grid, List, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from "@mui/material";
import { TableChart as TableViewIcon, ExpandMore as ExpandMoreIcon, Clear } from '@mui/icons-material';
import { useAppDispatch } from "../../../stores/hooks";
import { useEffect, useState } from "react";
import { TocOutputTables } from "../../../data/interfaces/configurationmodels";
import configService from "../../../data/api/config.service";
import { showsuccessmessage, showwarningmessage } from "../../../stores/notificationslice";
import { OutputTableInfo } from "../../../data/interfaces/sharedmodels";

export default function OutputTableConfig(){

    const dispatch=useAppDispatch();
    const [tocOutputtables, setTocOutputtable] = useState<TocOutputTables>({OutputTables:[],TocOutputTablesList:[]});
    //const [tocOutputtables, setTocOutputtable] = useState<TocOutputTables>(dummyTocOutputTables);
    const [selectedToc, setSelectedToc] = useState<number>(0);
    const [selectedType, setSelectedType] = useState<number>(0);

    useEffect(() => {
        loadTocOutputtables();
        
    }, []);

    const loadTocOutputtables=()=>{
        configService.GetTocOutputTables().then((response) => {
            setTocOutputtable(response.data);
        });
    }


    useEffect(() => {
        if (tocOutputtables && tocOutputtables.OutputTables.length && selectedToc < 1) {
            setSelectedToc(tocOutputtables.TocOutputTablesList[0].TocId);
            setSelectedType(1);
        }
    }, [tocOutputtables]);


    const handleSave=()=>{
       
        if(tocOutputtables.TocOutputTablesList.findIndex(a=>a.TocToOutputTables.findIndex(b=>(b.Id==null&&!b.IsDeleted)||(b.Id!=null&& b.IsDeleted))>-1)<0){
            dispatch(showwarningmessage("No data has changed."));return;
        }

        let tocOutputtable=tocOutputtables.TocOutputTablesList.filter(a=>a.TocToOutputTables.findIndex(b=>(b.Id==null&&!b.IsDeleted)||(b.Id!=null&& b.IsDeleted))>-1);
        configService.UpdateTocOutputtable(tocOutputtable).then((response)=>{
            loadTocOutputtables();
            dispatch(showsuccessmessage("The output table configuration data saved successfully."));
        })
    }
    
    const handleOnToggleDataTable = (checked: boolean, outputtable: OutputTableInfo) => {
       
        let tempTocoutputtables:TocOutputTables = { ...tocOutputtables };
        if (tempTocoutputtables.TocOutputTablesList && tempTocoutputtables.TocOutputTablesList.filter(a => a.TocId == selectedToc)[0]
            .TocToOutputTables.findIndex(m =>  m.OutputTableId == outputtable.Id) > -1) {

                tempTocoutputtables.TocOutputTablesList.filter(a => a.TocId == selectedToc)[0]
                .TocToOutputTables.filter(m =>  m.OutputTableId == outputtable.Id)[0].IsDeleted = !checked;

        }
        else {
            tempTocoutputtables.TocOutputTablesList?.filter(a => a.TocId == selectedToc)[0]
                .TocToOutputTables.push({Id:null,OutputTableId:outputtable.Id,Description:null,IsDeleted:false});
        }
        
        setTocOutputtable(tempTocoutputtables);
    }
    const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false);
    };

    const [expanded, setExpanded] = useState<string | false>('globaltables');
    const uniqueTicketTypeIds = [...new Set(tocOutputtables.OutputTables.map(outputtable => outputtable.TicketType))];

    return(
        <Box component={Paper} sx={{mt:2}}>
            <Grid container spacing={2} >
           
            <Grid xs={4}>
                <Box component={Paper} sx={{ml:2, p:2  }}>
                <Typography variant="h6">TOCs</Typography>
                    <List disablePadding={true}>
                        {
                          selectedToc ?  tocOutputtables?.TocOutputTablesList.map(function (toc) {
                                return (
                                    <ListItemButton key={toc.TocId} selected={selectedToc === toc.TocId}
                                        onClick={(event) => setSelectedToc(toc.TocId)}>
                                        <ListItemText primary={toc.TocName} />
                                    </ListItemButton>)
                            })
                        :null}
                    </List>
                </Box>
            </Grid>
            <Grid xs={4}>
                <Box component={Paper} sx={{ p:2  }}>
                <Typography variant="h6">Ticket Types</Typography>
                    <List disablePadding={true}>
                        {
                          selectedType ?  uniqueTicketTypeIds.map(function (TicketTypeId) {
                                return (
                                    <ListItemButton key={TicketTypeId} selected={selectedType === TicketTypeId}
                                        onClick={(event) => setSelectedType(TicketTypeId)}>
                                        <ListItemText primary={TicketTypeId == 1 ? 'Magnetic': 'ITSO'} />
                                    </ListItemButton>)
                            })
                       :null }
                    </List>
                </Box>
            </Grid>
            <Grid xs={4}>
                <Box component={Paper} sx={{ p:2 }}>
                    <Typography variant="h6">OutputTables</Typography>
                    { tocOutputtables.OutputTables.findIndex(a => a.IsGlobal)>-1 ?
                    <Accordion expanded={true} onChange={handleChange('globaltables')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="globaltables-content"
                            id="globaltables-header"
                        >
                            <Typography variant="h6">Global OutputTables</Typography>
                        </AccordionSummary>
                        <AccordionDetails>

                            <List dense={true} disablePadding={true}>
                                {
                              tocOutputtables && tocOutputtables?.TocOutputTablesList.length &&  selectedToc && selectedType ?
                                 tocOutputtables.OutputTables.filter(a => a.IsGlobal && selectedType===a.TicketType).map(function (table) {
                                        return (
                                            <ListItemButton >
                                               <ListItemIcon>
                                                <Checkbox
                                                    edge="start"
                                                    onChange={(e)=>handleOnToggleDataTable(e.target.checked,table)}
                                                    checked={tocOutputtables?.TocOutputTablesList.filter(a =>  a.TocId == selectedToc )[0].TocToOutputTables.findIndex(b => b.OutputTableId == table.Id&&b.IsDeleted==false) > -1}
                                                    tabIndex={-1}
                                                    disableRipple
                                                    inputProps={{ 'aria-labelledby':  table.Description }} />
                                            </ListItemIcon>
                                            <ListItemText primary={table.Name + ' - '+ table.Description} />
                                            </ListItemButton>)
                                    })
                                :null}
                            </List>
                        </AccordionDetails>
                    </Accordion>:null}
                    {tocOutputtables.OutputTables.findIndex(a => !a.IsGlobal)>-1?
                    <Accordion expanded={true} onChange={handleChange('stationtables')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="stationtables-content"
                            id="stationtables-header"
                        >
                            <Typography variant="h6">Station Specific OutputTables</Typography>
                        </AccordionSummary>
                        <AccordionDetails>

                            <List dense={true} disablePadding={true}>
                                {
                               tocOutputtables && tocOutputtables?.TocOutputTablesList.length &&   selectedToc && selectedType ?   tocOutputtables.OutputTables.filter(a => !a.IsGlobal && selectedType===a.TicketType).map(function (table) {
                                        return (
                                            <ListItemButton >
                                            <ListItemIcon>
                                             <Checkbox
                                                 edge="start"
                                                 onChange={(e)=>handleOnToggleDataTable(e.target.checked,table)}
                                                 checked={tocOutputtables?.TocOutputTablesList.filter(a => a.TocId == selectedToc)[0].TocToOutputTables.findIndex(b =>  b.OutputTableId == table.Id&&b.IsDeleted==false) > -1}
                                                 tabIndex={-1}
                                                 disableRipple
                                                 inputProps={{ 'aria-labelledby': table.Description }} />
                                         </ListItemIcon>
                                         <ListItemText primary={table.Name + ' - '+ table.Description} />
                                         </ListItemButton>)
                                    })
                                :null}
                            </List>
                        </AccordionDetails>
                    </Accordion>:null}
                </Box>
            </Grid>
            <Grid xs={12}>
                 <Button variant="contained"  sx={{float:"right",m:2}} onClick={handleSave}>Save All Changes</Button>
            </Grid>
        </Grid>
        </Box>
    )
}